webpackJsonp([204054128319469],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	__webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'questions-hero' },
	      _react2.default.createElement('div', { className: 'questions-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'questions-title' },
	      '10 Questions'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'questions-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'why', current: 'questions' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Equipment Leasing Association recommends businesses ask the following 10 questions before signing a lease. These questions take into account the "before, during and after" stages of a lease.'
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Before'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'How am I planning to use this equipment in my business and how long will I need it?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Does the leasing representative understand my business and how this transaction helps me do business?'
	        ),
	        _react2.default.createElement(
	          'strong',
	          null,
	          'During'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'What is the total lease payment and are there any other costs that I could incur before the lease ends?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'What happens if I want to change this lease or end the lease early?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'How am I responsible if the equipment is damaged or destroyed?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'What are my obligations for the equipment (such as insurance, taxes and maintenance) during the lease?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Can I upgrade the equipment or add equipment under this lease?'
	        ),
	        _react2.default.createElement(
	          'strong',
	          null,
	          'After'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'What are my options at the end of the lease?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'What are the procedures I must follow if I choose to return the equipment?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Are there any extra costs at the end of the lease?'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-questions-js-e0d82cba287198a505bd.js